import paper from "paper";
// start : x : 100, y : 0
const path1 = [[
    { x: 100, y: 0 },
    { x: 120, y: 200 },
    { x: 125, y: 295 },
    { x: 170, y: 350 }
], [
    { x: 170, y: 350 },
    { x: 320, y: 500 },
    { x: 550, y: 500 },
    { x: 800, y: 630 }
], [
    { x: 800, y: 630 },
    { x: 820, y: 650 },
    { x: 900, y: 550 },
    { x: 1000, y: 700 }
], [
    { x: 1000, y: 700 },
    { x: 1220, y: 770 },
    { x: 1400, y: 800 },
    { x: 1600, y: 750 }
], [
    { x: 1600, y: 750 },
    { x: 1750, y: 770 },
    { x: 1950, y: 780 },
    { x: 2200, y: 550 }
], [
    { x: 2200, y: 550 },
    { x: 2750, y: 550 },
    { x: 3000, y: 480 },
    { x: 2920, y: 50 }
], [
    { x: 2920, y: 50 },
    { x: 2750, y: -450 },
    { x: 3000, y: -460 },
    { x: 2320, y: -550 }
], [
    { x: 2320, y: -550 },
    { x: 2150, y: -550 },
    { x: 1800, y: -760 },
    { x: 1520, y: -750 }
], [
    { x: 1520, y: -750 },
    { x: 1300, y: -750 },
    { x: 1000, y: -460 },
    { x: 850, y: -550 }
], [
    { x: 850, y: -550 },
    { x: 740, y: -690 },
    { x: 650, y: -560 },
    { x: 600, y: -510 }
], [
    { x: 600, y: -510 },
    { x: 180, y: -490 },
    { x: 130, y: -160 },
    { x: 100, y: 0 }
]
];




const path2 = [
    [
        { x: 100, y: 0 },
        { x: 400, y: 300 },
        { x: 700, y: 500 },
        { x: 1000, y: 500 }
    ],
    [
        { x: 1000, y: 500 },
        { x: 1200, y: 500 },
        { x: 1400, y: 300 },
        { x: 1650, y: 335 }
    ],
    [
        { x: 1650, y: 335 },
        { x: 1700, y: 350 },
        { x: 2600, y: 600 },
        { x: 2700, y: 0 }
    ],
    [
        { x: 2700, y: 0 },
        { x: 2600, y: -700 },
        { x: 1800, y: -600 },
        { x: 1500, y: -500 }
    ],
    [
        { x: 1500, y: -500 },
        { x: 1300, y: -500 },
        { x: 400, y: -400 },
        { x: 100, y: 0 }
    ]
];

const path3 = [
    [
        { x: 100, y: 0 },
        { x: 400, y: -800 },
        { x: 1300, y: -300 },
        { x: 1500, y: -600 }
    ],
    [
        { x: 1500, y: -600 },
        { x: 1700, y: -800 },
        { x: 2200, y: -400 },
        { x: 2400, y: -200 }
    ],
    [
        { x: 2400, y: -200 },
        { x: 2900, y: 0 },
        { x: 2900, y: 300 },
        { x: 2400, y: 330 }
    ],
    [
        { x: 2400, y: 330 },
        { x: 2200, y: 330 },
        { x: 1700, y: 850 },
        { x: 1550, y: 750 }
    ],
    [
        { x: 1550, y: 750 },
        { x: 1300, y: 430 },
        { x: 300, y: 650 },
        { x: 100, y: 0 }
    ]
];


const path4 = [
    [
        { x: 100, y: 0 },
        { x: 400, y: 300 },
        { x: 700, y: 200 },
        { x: 1000, y: 320 }
    ],
    [
        { x: 1000, y: 320 },
        { x: 700, y: 600 },
        { x: 400, y: 500 },
        { x: 300, y: 450 }
    ], [
        { x: 300, y: 450 },
        { x: 200, y: 150 },
        { x: 0, y: -50 },
        { x: 500, y: -200 }
    ], [
        { x: 500, y: -200 },
        { x: 1000, y: -450 },
        { x: 1900, y: -500 },
        { x: 2400, y: -340 }
    ],
    [
        { x: 2400, y: -340 },
        { x: 3200, y: 0 },
        { x: 2800, y: 200 },
        { x: 2550, y: 500 }
    ],
    [
        { x: 2550, y: 500 },
        { x: 2200, y: 700 },
        { x: 1500, y: 300 },
        { x: 900, y: 500 }
    ],
    [
        { x: 900, y: 500 },
        { x: 700, y: 600 },
        { x: 200, y: 200 },
        { x: 100, y: 0 }
    ]
];



// start : x : 2972, y : 0
const path5 = [
    [
        { x: 2972, y: 0 },
        { x: 2700, y: 0 },
        { x: 2500, y: -100 },
        { x: 2350, y: -200 }
    ],
    [
        { x: 2350, y: -200 },
        { x: 2000, y: -400 },
        { x: 1200, y: -500 },
        { x: 850, y: -270 }
    ],
    [
        { x: 850, y: -270 },
        { x: 700, y: -200 },
        { x: 800, y: -500 },
        { x: 340, y: -480 }
    ],
    [
        { x: 340, y: -480 },
        { x: -50, y: -350 },
        { x: 400, y: -50 },
        { x: 540, y: 130 }
    ],
    [
        { x: 540, y: 130 },
        { x: 800, y: 400 },
        { x: 1400, y: 600 },
        { x: 1600, y: 600 }
    ],
    [
        { x: 1600, y: 600 },
        { x: 1800, y: 400 },
        { x: 2500, y: 600 },
        { x: 2972, y: 0 }
    ]
];


const path6 = [
    [
        { x: 2972, y: 0 },
        { x: 2500, y: -400 },
        { x: 2100, y: -700 },
        { x: 1600, y: -720 }
    ],
    [
        { x: 1600, y: -720 },
        { x: 1200, y: -700 },
        { x: 800, y: -400 },
        { x: 400, y: -50 }
    ],
    [
        { x: 400, y: -50 },
        { x: 450, y: 200 },
        { x: 900, y: 600 },
        { x: 1200, y: 560 }
    ],
    [
        { x: 1200, y: 560 },
        { x: 1600, y: 530 },
        { x: 2100, y: 600 },
        { x: 2500, y: 300 }
    ],
    [
        { x: 2500, y: 300 },
        { x: 2600, y: 200 },
        { x: 2800, y: 100 },
        { x: 2972, y: 0 }
    ]

];


const path7 = [
    [
        { x: 2972, y: 0 },
        { x: 2600, y: 600 },
        { x: 2000, y: 600 },
        { x: 1700, y: 500 }
    ],
    [
        { x: 1700, y: 500 },
        { x: 1300, y: 400 },
        { x: 750, y: 600 },
        { x: 250, y: 150 }
    ],
    [
        { x: 250, y: 150 },
        { x: 550, y: -800 },
        { x: 1250, y: -300 },
        { x: 1550, y: -550 }
    ],
    [
        { x: 1550, y: -550 },
        { x: 1850, y: -800 },
        { x: 2672, y: 0 },
        { x: 2972, y: 0 }
    ]
];

const path8 = [
    [
        { x: 2972, y: 0 },
        { x: 2500, y: 400 },
        { x: 2100, y: 300 },
        { x: 1700, y: 335 }
    ],
    [
        { x: 1700, y: 335 },
        { x: 1400, y: 400 },
        { x: 470, y: 500 },
        { x: 170, y: 335 }
    ],
    [
        { x: 170, y: 335 },
        { x: 40, y: 100 },
        { x: 400, y: -400 },
        { x: 800, y: -450 }
    ],
    [
        { x: 800, y: -450 },
        { x: 1500, y: -600 },
        { x: 2200, y: -400 },
        { x: 2972, y: 0 }
    ]
];


const path9 = [
    [
        { x: 1536, y: 724 },
        { x: 1336, y: 800 },
        { x: 1100, y: 600 },
        { x: 770, y: 600 }
    ],
    [
        { x: 770, y: 600 },
        { x: 500, y: 530 },
        { x: 350, y: 500 },
        { x: 150, y: 300 }
    ],
    [
        { x: 150, y: 300 },
        { x: 100, y: 200 },
        { x: 250, y: -350 },
        { x: 700, y: -580 }
    ],
    [
        { x: 700, y: -580 },
        { x: 1200, y: -600 },
        { x: 1800, y: -750 },
        { x: 2300, y: -550 }
    ],
    [
        { x: 2300, y: -550 },
        { x: 2700, y: -400 },
        { x: 3000, y: 200 },
        { x: 2472, y: 400 }
    ],
    [
        { x: 2472, y: 400 },
        { x: 2200, y: 500 },
        { x: 1700, y: 700 },
        { x: 1536, y: 724 }
    ]
];


const path10 = [
    [
        { x: 1536, y: 724 },
        { x: 1536, y: 0 },
        { x: 2200, y: 600 },
        { x: 2600, y: 300 }
    ],
    [
        { x: 2600, y: 300 },
        { x: 2800, y: 100 },
        { x: 2800, y: -100 },
        { x: 2300, y: -250 }
    ],
    [
        { x: 2300, y: -250 },
        { x: 1800, y: -600 },
        { x: 1000, y: -500 },
        { x: 500, y: -350 }
    ],
    [
        { x: 500, y: -350 },
        { x: -50, y: 0 },
        { x: 200, y: 300 },
        { x: 1536, y: 724 }
    ],

];

const path11 = [
    [
        { x: 1536, y: 724 },
        { x: 1200, y: 400 },
        { x: 400, y: 400 },
        { x: 100, y: 0 }
    ],
    [
        { x: 100, y: 0 },
        { x: 700, y: -200 },
        { x: 1700, y: -700 },
        { x: 2300, y: -550 }
    ],
    [
        { x: 2300, y: -550 },
        { x: 3400, y: -200 },
        { x: 2700, y: 300 },
        { x: 2500, y: 470 }
    ],
    [
        { x: 2500, y: 470 },
        { x: 2200, y: 470 },
        { x: 1800, y: 500 },
        { x: 1536, y: 724 }
    ]
];


const path12 = [
    [
        { x: 1536, y: 724 },
        { x: 1600, y: 400 },
        { x: 2500, y: 400 },
        { x: 2600, y: 200 }
    ],
    [
        { x: 2600, y: 200 },
        { x: 2300, y: 400 },
        { x: 1000, y: 600 },
        { x: 770, y: 600 }
    ],
    [
        { x: 770, y: 600 },
        { x: 0, y: 400 },
        { x: 250, y: 0 },
        { x: 350, y: 0 }
    ],
    [
        { x: 350, y: 0 },
        { x: 700, y: 400 },
        { x: 1200, y: 300 },
        { x: 1536, y: 724 }
    ]
];


const path13 = [
    [
        { x: 1536, y: -724 },
        { x: 1000, y: -700 },
        { x: 700, y: -600 },
        { x: 200, y: -100 }
    ],
    [
        { x: 200, y: -100 },
        { x: 1000, y: -700 },
        { x: 1500, y: -600 },
        { x: 2300, y: -400 }
    ],
    [
        { x: 2300, y: -400 },
        { x: 2500, y: 0 },
        { x: 2700, y: -300 },
        { x: 2800, y: 40 }
    ],
    [
        { x: 2800, y: 40 },
        { x: 2200, y: -600 },
        { x: 1600, y: -720 },
        { x: 1536, y: -724 }
    ]
];

const path14 = [
    [
        { x: 1536, y: -724 },
        { x: 1000, y: -300 },
        { x: 700, y: -300 },
        { x: 240, y: -100 }
    ],
    [
        { x: 240, y: -100 },
        { x: 400, y: 600 },
        { x: 900, y: 500 },
        { x: 1000, y: 500 }
    ],
    [
        { x: 1000, y: 500 },
        { x: 1700, y: 400 },
        { x: 2000, y: 400 },
        { x: 2700, y: 200 }
    ],
    [
        { x: 2700, y: 200 },
        { x: 2800, y: -400 },
        { x: 2700, y: -400 },
        { x: 2200, y: -600 }
    ],
    [
        { x: 2200, y: -600 },
        { x: 2000, y: -300 },
        { x: 1700, y: -300 },
        { x: 1536, y: -724 }
    ]
];
// [path1, path2, path3, path4, path5];
const paths = [path1, path2, path3, path4, path5, path6, path7, path8, path9, path10, path11, path12, path13, path14];


function moveMobInBezierCurve (points, ball) {
    let [p0, p1, p2, p3] = points;

    let cx = 3 * (p1.x - p0.x);
    let bx = 3 * (p2.x - p1.x) - cx;
    let ax = p3.x - p0.x - cx - bx;

    let cy = 3 * (p1.y - p0.y);
    let by = 3 * (p2.y - p1.y) - cy;
    let ay = p3.y - p0.y - cy - by;

    let t = ball.t;

    ball.t += ball.speed;

    let xt = ax * (t * t * t) + bx * (t * t) + cx * t + p0.x;
    let yt = ay * (t * t * t) + by * (t * t) + cy * t + p0.y;


    ball.x = xt;
    ball.y = yt;

    return ball;

}

function getMovementAngle (x1, y1, x2, y2) {
    return Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI;
}

let prevPath = 0;

function drawPath (path, currentPath) {
    let testFish = { x: 100, y: 50, speed: 0.01, t: 0 };

    path.forEach(function (points, index) {

        points.forEach(function (point) {
            const pointDot = new paper.Path.Circle([point.x, point.y], 3);
            pointDot.fillColor = "black";
            pointDot.selected = true;
            const coordinate = new paper.PointText([point.x, point.y - 10]);
            coordinate.content = `[${ point.x },${ point.y }]`;
            coordinate.fillColor = "black";
            coordinate.justification = "center";
            coordinate.fontSize = 20;
            coordinate.fontWeight = 5;
        });

        let currentPoints = points;
        while (testFish.t < 1) {
            let prevBall = Object.assign({}, testFish);

            testFish = moveMobInBezierCurve(currentPoints, testFish);

            if (prevPath !== currentPath) {
                prevPath = currentPath;
                prevBall = Object.assign({}, testFish);
            }

            const line = new paper.Path([prevBall.x, prevBall.y], [testFish.x, testFish.y]);
            line.strokeWidth = 2;
            line.strokeColor = "black";
        }
        prevPath = currentPath;
        testFish.t = 0;
    });

}




export { moveMobInBezierCurve, paths, drawPath, getMovementAngle };